export const NUM_OF_COLUMNS = 5;
export const NUM_OF_COLUMNS_MOBILE = 2;
export const SectionContentGridFormat = `repeat(${NUM_OF_COLUMNS},  minmax(0, 1fr))`;
export const SectionContentGridMobileFormat = `repeat(${NUM_OF_COLUMNS_MOBILE},  minmax(0, 1fr))`;
